import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; 
// project-imports
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import axios from 'axios';

// ==============================|| AUTH GUARD ||============================== //
const setSession = (serviceToken?: string | null) => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    axios.defaults.headers.common.authToken = `${serviceToken}`;
  } else {
    localStorage.removeItem('serviceToken');
    delete axios.defaults.headers.common.authToken;
  }
};
const AuthGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, user, tokenRemoved } = useAuth();
  const isLoggedInUserType =user?.type ?? '';
  const navigate = useNavigate();
  const location = useLocation();

  const userType = ['admin', 'sub-admin', 'superAdmin', 'manager', 'faculty', 'teacher', 'student'];




  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/');
    } else if (!isLoggedIn && location.pathname !== '/blog/viewblog' && !location.pathname.startsWith('/learner/account/accomplishments/verify')) {
      navigate('/login');
    } else if (user && (user?.type !== 'student') && location?.pathname?.split('/')?.[1] === 'learner') {
      navigate('/');
    } else if ((user?.type === 'student')&& location?.pathname?.split('/')?.[1] !== 'learner') {
      navigate('/learner');
    } else if (!user && !isLoggedIn && location.pathname.startsWith('/learner/account/accomplishments/verify')) {
      navigate(location.pathname)
    }
  }, [isLoggedIn, navigate, location]);

  useEffect(() => {
    if (isLoggedIn && isLoggedInUserType !== '' && userType.includes(isLoggedInUserType)) {
      let updatedUrl;
      const words = location?.pathname?.split('/');
      const lastWord = words?.[words?.length - 1];

      if (lastWord === 'edit') {
        updatedUrl = location?.pathname?.replace(/\/edit$/, '');
        updatedUrl === '/users' ? navigate(`${updatedUrl}/admin`) : navigate(`${updatedUrl}`);
      }
    }
  }, []);
  useEffect(() => {
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error?.response?.status === 401) {
          setSession();
          navigate('/login', {
            state: {
              unauthorized: true
            },
            replace: true
          });
        }
        return Promise.reject(
          error instanceof Error ? error : new Error(error?.message ?? 'Request failed')
        );
      }
    );
  }, []);
  useEffect(() => {
    let interval = setInterval(() => {
      if (!user && !isLoggedIn && location.pathname.startsWith('/learner/account/accomplishments/verify')) return;

      let token: any = localStorage.getItem('serviceToken');
      let decodedToken: any = () => {
        if (token) {
          return jwtDecode(token);
        }
        return { exp: 0 };
      };
      let currentDate = new Date();
      // JWT exp is in seconds
      if (decodedToken().exp * 1000 < currentDate.getTime()) {
        setSession();
        clearInterval(interval);
        navigate('/login');
        tokenRemoved()
      }
    }, 10000);
  }, []);
  return children;
};

export default AuthGuard;
